import { render } from "./AlarmRegModal.vue?vue&type=template&id=1628ac4c&scoped=true"
import script from "./AlarmRegModal.vue?vue&type=script&lang=js"
export * from "./AlarmRegModal.vue?vue&type=script&lang=js"

import "./AlarmRegModal.vue?vue&type=style&index=0&id=1628ac4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1628ac4c"]])

export default __exports__